module.exports = __webpack_public_path__ + "static/media/paneer.60816264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paneer.jpg
// module id = 201
// module chunks = 0